import { Shield } from 'lucide-react';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import { t } from '@/lib/translations';

export default function CookieBanner() {
  const { 
    acceptEssentialOnly, 
    acceptAll, 
    hasDoNotTrack 
  } = useCookieConsent();

  const handleAcceptAll = () => {
    acceptAll();
  };

  const handleAcceptEssential = () => {
    acceptEssentialOnly();
  };

  const handleManageSettings = () => {
    window.location.href = '/cookie-settings';
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 p-4 md:p-6" data-testid="cookie-banner">
      <div className="glassmorphism-card max-w-4xl mx-auto">
        <div className="p-6 md:p-8">
          {/* Header */}
          <div className="mb-6">
            <h3 className="text-xl font-semibold text-gray-900 mb-2">
              {t('cookies.title')}
            </h3>
            <p className="text-gray-700 text-sm leading-relaxed">
              {t('cookies.description')}
            </p>
          </div>

          {/* Do Not Track Notice */}
          {hasDoNotTrack && (
            <div className="mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg">
              <p className="text-blue-800 text-sm">
                <Shield className="w-4 h-4 inline mr-2" />
                {t('cookies.doNotTrackNotice')}
              </p>
            </div>
          )}

          {/* Privacy Policy Link */}
          <div className="mb-4">
            <a
              href="/privacy-policy"
              className="text-sm font-medium transition-colors"
              data-testid="link-privacy-policy"
              style={{ color: '#4f46e5', textDecoration: 'underline' }}
            >
              {t('landing.privacyPolicy')}
            </a>
          </div>

          {/* Main Action Buttons - Equal Prominence (GDPR: reject must be as easy as accept) */}
          <div className="flex flex-col sm:flex-row gap-3 w-full">
            <button
              onClick={handleAcceptAll}
              className="glassmorphism-button w-full sm:flex-1"
              data-testid="button-accept-all"
            >
              {t('cookies.acceptAll')}
            </button>

            <button
              onClick={handleAcceptEssential}
              className="glassmorphism-button w-full sm:flex-1"
              data-testid="button-reject-non-essential"
            >
              {t('cookies.rejectNonEssential')}
            </button>
            
            <button
              onClick={handleManageSettings}
              className="glassmorphism-button w-full sm:flex-1"
              data-testid="button-manage-settings"
            >
              {t('cookies.customize')}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}